import { render, staticRenderFns } from "./BankAccountModal.vue?vue&type=template&id=63f54b8e"
import script from "./BankAccountModal.vue?vue&type=script&lang=js"
export * from "./BankAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports